import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../../core/store/reducers";
import { FetchStateType } from "../../../../models";
import { upsertClientContract } from "../../thunks/clientContract/upsertClientContract";
import { setFetchStateContract } from "../../clientsDataReducer";
import { ClientContract } from "../../types";

export const useClientContractUpsert = () => {
	const fetchState = useSelector<StoreType, FetchStateType>(
		store => store.data.listing.clients.fetchStateContract
	);

	const dispatch = useDispatch();
	const dispatchUpsertContract = React.useCallback(
		(contract: ClientContract) => dispatch(upsertClientContract(contract)),
		[dispatch]
	);

	React.useEffect(() => {
		dispatch(setFetchStateContract({ type: "not-started" }))
	}, [dispatch])

	return [fetchState, dispatchUpsertContract] as [typeof fetchState, typeof dispatchUpsertContract]
};
